import { render, staticRenderFns } from "./TickField.vue?vue&type=template&id=27d860f5&"
import script from "./TickField.vue?vue&type=script&lang=js&"
export * from "./TickField.vue?vue&type=script&lang=js&"
import style0 from "./TickField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports